<loader-overlay-component [show]="isloading"></loader-overlay-component>
<div class="dmv-search-results inner-home">
    <div class="container">
      <div class="row no-margin">
        <!--heading section starts here-->
        <div class="col-6 col-sm-2 mt-4 ">
           <a >
             <button class="btn btn-primary btn-back top-back-button"
              (click)="goBack()"><i class="fa fa-chevron-left text-left" ></i> Back</button>
          </a>  
        </div>
  
        <div class="col-12 col-sm-8 mt-4">
          <div id="searchResu">Search Results</div>
          <div id="addthereco">
          <div class="subtitle">Add</div>
            <div class="subtitle list-btn-add">
            <button  class="list-btn add" [style.background-color]="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.secondaryColor"><div></div><div></div></button></div><div class="subtitle"> registration(s) you wish to renew:</div> </div>
        </div>
  
  
        <div class="col-6 col-sm-2 icon-cart mt-4">
          <dmv-shoping-cart [registrationsInCart]="dmvStoreService?.registrationsInCart?.dmvRegistrations"></dmv-shoping-cart>
        </div>
  
        <!--heading section ends here-->
       
         <div class="alert alert-info" *ngIf="(dmvStoreService.registrationData$ | async).totalPageCount>1">
          &nbsp;There are {{(dmvStoreService.registrationData$ | async).totalPageCount}} pages of registrations. Please add all registrations you wish to renew before continuing.
        </div>
        <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
          &nbsp;<span [innerHTML]="errorMessage"></span>
        </div>
        <div class="col-12" id="rectangle"
        [ngClass]="((!registration.availableRenewalOptions ||(registration.availableRenewalOptions && registration.availableRenewalOptions?.length===0 )) && !registration.allowPlateChange) ? 'rectangle-disabled' : ''"
        
        
        *ngFor="let registration of (dmvStoreService.registrationData$ | async).registrations">
        <!-- <div *ngIf="((!registration.availableRenewalOptions ||(registration.availableRenewalOptions && registration.availableRenewalOptions?.length===0 )) && !registration.allowPlateChange)" class ="registrationNotAvailable">Not Available<br/>for Renewal</div> -->

        
          <div class="row no-margin mt-3 mb-3">
           
              <div class="col-6">
                <div class="rectangle-wrapper">
                  <div id="pin">pin:</div>
                  <div id="pin-number">{{registration.pinNumber}}</div>
                </div>
              </div>
              <div class="col-6">
                <div class="rectangle-wrapper">
                  <div id="pin">plate:</div>
                  <div id="pin-number">{{registration.licensePlate}}</div>
                </div>
              </div>
  
              <div class="col-12 col-sm-6">
                <div class="rectangle-wrapper">
                  <div id="pin">make:</div>
                  <div class="merc-number">{{registration.makeModel}}</div>
                </div>
              </div>
              <div class="col-12 col-sm-6">
                <div class="rectangle-wrapper eligibilityWarningContainer">
                  <div class="expirationField">
                  <div id="pin">Expiration:</div>
                  <div class="merc-number">{{formatedDate(registration.expirationDate) | date:'MM/dd/yyyy'}}</div>
                  <div *ngIf="(!registration.availableRenewalOptions ||(registration.availableRenewalOptions && registration.availableRenewalOptions?.length===0 )) && registration.allowPlateChange"  class="renewedText" >Plate change only!</div>
                  </div>
                  <div *ngIf="registration.availableRenewalOptions?.length>0 && registration.eligibilityWarning"  class="renewedText" >{{registration.eligibilityWarning}}</div>
                
                </div>
              </div>
          
            
  
            <div *ngIf="!((!registration.availableRenewalOptions ||(registration.availableRenewalOptions && registration.availableRenewalOptions?.length===0 )) && !registration.allowPlateChange)" class="icon-success"  [ngClass]="(isInCart(registration)) ? ' list-btn-added' : ' list-btn-add'">
                <button (click)="removeInCart(registration)" class="list-btn added" ><i class="fa fa-check"></i></button> 

                <button (click)="addInCart(registration)" class="list-btn add" [style.background-color]="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.secondaryColor"><div></div><div></div></button>
             
            </div>
  
          </div>
          <div *ngIf="((!registration.availableRenewalOptions ||(registration.availableRenewalOptions && registration.availableRenewalOptions?.length===0 )) && !registration.allowPlateChange)" class ="registrationNotAvailable">
            <span class="registrationNotAvailableText">Not Available for Renewal</span>
            <div class="popover__wrapper ineligibilityTextWrapper"  *ngIf="registration.ineligibilityText" >
                  <i class="icon-group-10" > <svg-image color="#dc3545" name="question-mark" [width]="22" [height]="22"></svg-image>
                  </i>
            <div class="popover__content other-fees ineligibility" >
                <div class="ineligibilityText" [innerHTML]="registration.ineligibilityText">
  
                </div>
            </div>
        </div>
            
          </div>
        </div>
  
      </div>
  
      <nav class="navigationContainer" aria-label="Page navigation example" *ngIf=" (dmvStoreService.registrationData$ | async).totalPageCount>1">
        <ul class="pagination justify-content-center">
          <li class="page-item arrow-icon start-arrow" [class.disabled]="1  === currentPage" >
            <a (click)="paginationBack()">
              <i class="fa fa-play" aria-hidden="true"></i>
            </a>
          </li>
  
          <li class="page-item pagination-item" *ngFor="let pageNumber of pageNumbers" [class.active]="pageNumber  === currentPage"  (click)="pagination(pageNumber)" >
           
            <a ></a>
          </li>
          <li class="page-item arrow-icon end-arrow" [class.disabled]="(dmvStoreService.registrationData$ | async).totalPageCount  === currentPage">
            <a (click)="paginationNext()">
             <i class="fa fa-play" aria-hidden="true"></i>
            </a>
          </li>
        </ul>
      </nav>
  
      <form autocomplete="off"  *ngIf="qrCode || isExternalLint" class="text-left mb-5" [formGroup]="searchRegistrationForm">
        <div class="checkbox-container ">
         <div class="flex">
           <span>I have read and accept this <a (click)="openPrivacy()" class="privacy-txt">privacy statement</a>.
            <label>
               <input type="checkbox"  formControlName="privacy"   >
               <span class="checkmark"
               [ngStyle]="f?.privacy?.value?{'background-color':(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor} : {'background-color': 'transparent'}"
                 [style.border-color]="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor"></span>   
             </label> 
             </span>
           </div>
             <div class="alert alert-danger" style="margin-left: -25px;" role="alert" *ngIf="isPrivacy && !f?.privacy?.value">
               Please review and accept the  privacy statement. 
           </div>
     </div>
     </form>

      <div class="m-auto text-center" >
                  <a >
                        <button class="btn btn-primary btn-back" (click)="goBack()"><i class="fa fa-chevron-left text-left"></i> Back</button>
                    </a>  
                      <a>
          <button class="btn btn-primary btn-continue m-auto" (click)="continue()">Continue
            <i class="fa fa-chevron-right text-right"></i>
          </button>
        </a>
      </div>
  
  
    </div>
  </div>
  <dmv-privacy (closePopup)="closePrivacy()" [privacyPolicy]="dmvStoreService?.agencyConfig?.agencyDmvConfig?.privacyStatement" *ngIf="isPrivacyOpen"></dmv-privacy>